import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import {
  CreateRemoteSessionRequest,
  CreateRemoteSessionResponse,
  RemoteSessionListResponse,
  RemoteSessionLogsResponse,
} from '../types';

export class SaktiRemoteInspectionService {
  static async createSession(
    req: CreateRemoteSessionRequest
  ): Promise<CreateRemoteSessionResponse> {
    const response = await api.post<CreateRemoteSessionResponse>(
      SAKTI_API_CONFIG.SUPPORT_SESSIONS_PATH,
      req
    );
    return response.data;
  }

  static async cancelSession(sessionId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post<{ success: boolean; message: string }>(
      SAKTI_API_CONFIG.SUPPORT_SESSION_CANCEL(sessionId),
      {}
    );
    return response.data;
  }

  static async completeSession(sessionId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post<{ success: boolean; message: string }>(
      SAKTI_API_CONFIG.SUPPORT_SESSION_COMPLETE(sessionId),
      {}
    );
    return response.data;
  }

  static async getSessions(
    page = 1,
    limit = 20,
    status?: string
  ): Promise<RemoteSessionListResponse> {
    const params: Record<string, string | number> = { page, limit };
    if (status) params.status = status;
    const response = await api.get<RemoteSessionListResponse>(
      SAKTI_API_CONFIG.SUPPORT_SESSIONS_PATH,
      { params }
    );
    return response.data;
  }

  static async getSessionLogs(sessionId: string): Promise<RemoteSessionLogsResponse> {
    const response = await api.get<RemoteSessionLogsResponse>(
      SAKTI_API_CONFIG.SUPPORT_SESSION_LOGS(sessionId)
    );
    return response.data;
  }
}

export default SaktiRemoteInspectionService;
